import { css } from "aphrodite";
import { global, cardList } from "styles";
import BackButton from "./BackButton";

function NotFound() {
  return (
    <>
      <BackButton numberOfPages={2} />
      <div className={css(cardList.cardList)}>
        <h2 className={css(global.title)}>404 PAGE INTROUVABLE</h2>
        <p>Veuillez vérifier votre requête</p>
      </div>
    </>
  );
}

export default NotFound;
